module.exports = __webpack_public_path__ + "Circus Shelf-7cb72f059e8c88e2d5284ddad2208cd9.svg";